// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.invite").
factory("Invite", function inviteFactory($http) {
	"use strict";

	function Invite(data) {
		var dirty = false;

		angular.extend(this, {
			// Invite properties

			claimedAt: "0001-01-01T00:00:00Z",
			createdAt: "0001-01-01T00:00:00Z",
			email: "",
			id: 0,
			isClaimed: false,
			nodeId: null,
			roleId: null,
			senderId: null,
			token: "",

			// Public functions

			isDirty: function isDirty() {
				return dirty;
			},

			setDirty: function setDirty(state) {
				dirty = state;
			},

			load: function load() {
				var self = this;
				return $http.post("/invite/info/", {inviteId: this.id, token: this.token}).then(function success(response) {
					angular.extend(self, response.data.invite);
					return response.data;
				});
			},

			accept: function accept() {
				return $http.post("/invite/accept/", {inviteId: this.id, token: this.token}).then(function success(response) {
					return response.data;
				});
			},

			resend: function resend() {
				return $http.post("/invite/resend/" + this.id).then(function success(response) {
					return response.data;
				});
			},
		});

		if (data) {
			angular.extend(this, data);
		}
	}

	return Invite;
});
